import { RavenChip } from "@ravenappdev/raven-ui";
import type { RavenChipVariant } from "@ravenappdev/raven-ui";
import type { ChipProps as MuiChipProps } from "@mui/material/Chip";

export type ChipColorVariant =
  | "default"
  | "primary"
  | "secondary"
  | "success"
  | "warning"
  | "error"
  | "info";

export type ChipVariant = "filled" | "outlined";

export interface ChipProps extends Omit<MuiChipProps, "color" | "variant"> {
  colorVariant?: ChipColorVariant;
  chipVariant?: ChipVariant;
}

// `secondary` is an ESS tone with no package equivalent; it maps to the
// package's nearest brand tone for the semantic marker only — the paint
// still comes from MUI's `color` below.
const PACKAGE_TONE: Record<ChipColorVariant, RavenChipVariant> = {
  default: "default",
  primary: "primary",
  secondary: "primary",
  success: "success",
  warning: "warning",
  error: "error",
  info: "info",
};

export default function Chip({
  colorVariant = "default",
  chipVariant = "filled",
  ...rest
}: ChipProps) {
  return (
    <RavenChip
      size="small"
      // Two channels, deliberately: `colorVariant` is the package's
      // semantic marker (it drives the `raven-chip--*` class and the
      // grey-chip misuse warning), while MUI's `color` is what actually
      // paints, through ESS's copper palette rather than the package
      // stylesheet's hardcoded Material/purple values.
      colorVariant={PACKAGE_TONE[colorVariant]}
      color={colorVariant}
      chipVariant={chipVariant}
      {...rest}
    />
  );
}
